import { SafetyPlanTestID } from "@/constants/TestID";
import SafetyPlanSection, {
  LinkText,
} from "@/ui/components/profile/safetyPlan/SafetyPlanSection";
import type { LinkPressProps } from "@/ui/components/profile/safetyPlan/SafetyPlanSection";
import { joinTestIDs } from "@/utils/string.util";

interface WebsitesWithCrisisSkillsSectionProps {
  onLinkPress: (props: LinkPressProps) => void;
  url?: string;
}

const WebsiteWithCrisisSkillsSection = ({
  onLinkPress,
  url,
}: WebsitesWithCrisisSkillsSectionProps) => {
  const websitesWithCrisisSkills = url
    ? [
        <LinkText
          key={SafetyPlanTestID.WebsiteWithCrisisSkills}
          linkType="web"
          onPress={() => {
            onLinkPress({
              field: WebsiteWithCrisisSkillsSection.name,
              linkType: "web",
              text: url,
            });
          }}
          testID={SafetyPlanTestID.WebsiteWithCrisisSkills}
          text={url}
        />,
      ]
    : [];

  return (
    <SafetyPlanSection
      statements={websitesWithCrisisSkills}
      testID={joinTestIDs(SafetyPlanTestID.WebsiteWithCrisisSkills, "section")}
      title="Website with skills to use in crisis"
    />
  );
};

export default WebsiteWithCrisisSkillsSection;
